<template>
    <div>
        <myHeader :year="year" :month="month" @yearNum="yearNum" @monthNum="monthNum" />
        <div class="week">
            <span v-for="i in weekTxt" :key="i">{{ i }}</span>
        </div>
        <div class="content" v-if="dayList.length>0">
            <span
                :class="{
                    isNotMonth: isNotMonth(d),
                    day: !isNotMonth(d),
                    today: isToday(d),
                    choice: choiceColor(d),
                }"
                v-for="(d, index) in dayList"
                :key="index"
                @click="!isNotMonth(d)?choice(d):''"
                >{{ d.getDate() }}</span
            >
        </div>
    </div>
</template>

<script>
import dayjs from "dayjs";
import myHeader from "./header.vue";
import * as utils from "../utils";
export default {
    components: {
        myHeader,
    },
    props:{
    },
    data() {
        return {
            year: dayjs().get("year"),
            month: dayjs().get("month") + 1,
            weekTxt: ["日", "一", "二", "三", "四", "五", "六"],
            choiceDay:'',
            dayList:[]
        };
    },
    mounted() {
        this.getShowDays(this.year,this.month);
    },
    computed: {
        
    },
    methods: {
        two(){
            this.getShowDays(this.year,this.month);
        },
        //计算显示得天数,我们需要计算出指定得年和月得第一天,在当前星期里是周几,在朝前面移动出现得天数
        //在6航7列显示42个日期
        getShowDays(year,month) {
                this.dayList = []
                // 构造一个传入得年月日期对象
                let firstDay = new Date(year, month - 1, 1);
                // 通过getDay() 获取这一天在星期数里出现得位置(0-6)
                let weeks = firstDay.getDay();
                // 计算面板中得第一天
                if (weeks == 0) {
                    weeks = 7;
                }
                let firstDate = firstDay - weeks * 24 * 60 * 60 * 1000;
                // console.log(new Date(firstDate));
                // 计算42个日期数
                
                for (let i = 0; i < 42; i++) {
                    this.dayList.push(new Date(firstDate + i * 24 * 60 * 60 * 1000));
                }
                // console.log(this.choiceDay);
                // console.log(this.dayList);
    
                // return arr;
            
        },
        isNotMonth(d) {
            if (d.getMonth() + 1 != this.month && d.getYear() != this.year) {
                return true;
            }
            return false;
        },
        yearNum(v) {
            // console.log(v);
            this.year = v;
            this.getShowDays(this.year,this.month);
        },
        monthNum(v) {
            // console.log(v);
            this.month = v;
            this.getShowDays(this.year,this.month);
        },
        isToday(v) {
            let { year, month, day } = utils.formatTime(new Date());
            let { year: y, month: m, day: d } = utils.formatTime(v);
            return year == y && month == m && day == d;
        },
        choice(d){
            this.choiceDay = d
            let obj = {}
            obj.startDate = d
            obj.endDate = d
            obj.index=0
            this.$emit('day',obj)
            // this.$emit('close',true)
            // console.log(`${this.year}-${this.month}-${this.choiceDay.getDate()}`);
        },
        choiceColor(v){
            let { year, month, day } = utils.formatTime(this.choiceDay);
            let { year: y, month: m, day: d } = utils.formatTime(v);
            return year == y && month == m && day == d;
        }
    },
};
</script>

<style lang="scss" scoped>
.week {
    margin-top: 6px;
    height: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e4e7ed;
    padding-bottom: 2px;
    span {
        flex: 1;
        text-align: center;
    }
}
.content {
    width: 100%;
    padding-left: 1px;
    height: 235px;
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    .day {
        width: 45px;
        // margin-left: 1px;
        height: 39px;
        text-align: center;
        line-height: 38px;
        &:hover {
            color: #409eff;
            // font-weight: 700;
        }
    }
    .isNotMonth {
        color: #c0c4cc;
        width: 45px;
        // margin-left: 1px;
        height: 39px;
        text-align: center;
        line-height: 38px;
    }
    .today {
        color: #409eff;
        font-weight: 700;
    }
    .choice {
        background-color: #409eff;
        border-radius: 5px;
        color: #fff;
        &:hover{
            color:#fff ;
        }
    }
}
</style>